import { cookies, ONCE_LOADER, server } from 'config';
import Cookies from 'js-cookie';
import { defineStore } from 'pinia';
import { pinia } from 'plugins/store/index';
import { store as appStore } from 'store/app';
import { store as trackingStore } from 'store/tracking';
import { computed, ComputedRef, ref } from 'vue';

interface App extends Obj {
  ready:{
    app:boolean, // like router and app init
    globals:boolean, //may be mandatory to display website :/
    interface: boolean, // mandatory to display website
    loader:boolean, // new one here @todo ready when manifest etc loaded - usefull because may wait some uilib; manifest etc
    page:boolean, // page data
    firstPage:boolean, // set true only once
  }
  pageTransition?: object;
  is404: boolean,
  interaction: boolean;
  bgColor: string;
  disabled: boolean;
  introSeen: boolean;
  redirection: boolean;
  isInactive: boolean;
}

const useStore = defineStore('app', () => {
  
  const state = ref<App>({
    ready: {
      app:false,
      firstPage:false,
      page:false,
      globals:false,
      interface:false,
      loader:false
    },
    pageTransition: undefined,
    is404: false,
    interaction: false,
    bgColor: "#FFEAF9",
    disabled: false,
    redirection: false,
    introSeen:false,
    isInactive: false
  });

  // Getters
  const _readyExeptPage: O<ComputedRef<boolean>> = computed(()=> {
    return state.value.ready.app && state.value.ready.globals
  });


  //Actions

  // must init app entrypoint + router ready + locale loaded + routeCpn loaded
  const setAppReady = () => {
    state.value.ready.app = true;
  };

  // Pass specific color name from our colors array
  const setPageReady = (ready=true) => {
    state.value.ready.page = ready;
    if(ready && !state.value.ready.firstPage){
      state.value.ready.firstPage = true;

      if (ONCE_LOADER && trackingStore.consents.preferences && appStore.firstPageReady) {
        Cookies.set(cookies.loader, 'true');
      } 
    }
  }

  // Pass specific color name from our colors array
  const setGlobalsReady = () => {
    state.value.ready.globals = true;
  }
  // Pass specific color name from our colors array
  const setInterfaceReady = () => {
    state.value.ready.interface = true;
  }

  // set is 404
  const setIs404 = () => {
    state.value.is404 = true;
  }

  // set is no longer 404
  const setIsNot404 = () => {
    state.value.is404 = false;
  }
  
  const setLoaderReady = () => {
    state.value.ready.loader = true;
  }

  const setAppBgColor = (color: string) => {
    state.value.bgColor = color;
    document.body.style.backgroundColor = `rgb(${color})`;
  }

  const setPageTransition = (value? : object) => {
    state.value.pageTransition = value;
  }

  // Disable the whole app (no more buttons)
  const disableApp = (value : boolean) => {
    state.value.disabled = value;
  };

  const init = () => {
    if (server) return
    
    const interactionHandlers = () => {
      document.removeEventListener('click', interactionHandlers)
      document.removeEventListener('touch', interactionHandlers)
      state.value.interaction = true;
    }
    document.addEventListener('click', interactionHandlers)
    document.addEventListener('touch', interactionHandlers)
  }

  const setIntroSeen = (value: boolean) => {
    state.value.introSeen = value;
  }

  const toggleInactive = (value: boolean) => {
    state.value.isInactive = value;
  }

  const setRedirectionMode = () => {
    state.value.redirection = true;
  }

  return  {
    state,

    // getters
    is404: computed(() => state.value.is404),
    globalsReady: computed(() => state.value.ready.globals),
    firstPageReady: computed( () => state.value.ready.firstPage),
    ready: () => computed(() => {
      return state.value.ready.app && state.value.ready.page && state.value.ready.globals && state.value.ready.interface
    }),
    /** ready to render - all loaded but page */
    appReady: _readyExeptPage,

    //get current background color
    bgColor: computed(() => state.value.bgColor),
    isAPageTransition: computed(() => state.value.pageTransition),
    disabled: computed(() => state.value.disabled),
    introSeen: computed(() => state.value.introSeen),
    isInactive: computed(() => state.value.isInactive),
    redirection: computed(() => state.value.redirection),

    // actions
    setAppReady,
    setPageReady,
    setGlobalsReady,
    setInterfaceReady,
    setIs404,
    setIsNot404,
    setLoaderReady,
    setAppBgColor,
    setPageTransition,
    setRedirectionMode,
    disableApp,
    setIntroSeen,
    toggleInactive,
    init,
  }
});
export const store = useStore(pinia);
export default store;
store.init();
